module.exports = __webpack_public_path__ + "static/media/SF-7-A.56f62342.mp3";